import { useEffect } from "react";
import { Spinner } from "react-bootstrap";

const FullScreenLoader = ({ isLoading, message = "Loading..." }) => {
  // Disable body scroll when loading
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
      {message && (
        <p
          className="mt-3 text-black2D font-primary fw-medium fs-16"
          style={{ marginTop: 16 }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default FullScreenLoader;
